// Which keke, breakdown or stop a button points at. Hints only: the worker checks range again.

type Pos = { x: number; y: number };

/**
 * The nearest item within `range` of `me`, or null. Ties go to the lower id, so two phones
 * looking at the same scene always pick the same target.
 */
export function nearestWithin<T extends { id: string }>(
  me: Pos,
  items: Iterable<T>,
  pos: (t: T) => Pos | null | undefined,
  range: number,
): T | null {
  let best: T | null = null;
  let bestD = range * range;
  for (const it of items) {
    const p = pos(it);
    if (!p) continue;
    const d = (p.x - me.x) ** 2 + (p.y - me.y) ** 2;
    if (d < bestD || (d === bestD && (best === null || it.id < best.id))) {
      best = it;
      bestD = d;
    }
  }
  return best;
}
